import React from 'react';
import { Card, Block } from '@hz-design-system/web-ui';

import Skeleton from '../../components/Skeleton';
import Classes from './ListingSkeleton.scss';

const ListingSkeleton = () => (
  <Card className={Classes.root}>
    <Skeleton.Block width="100%" className={Classes.imageSkeleton} />
    <Block>
      <Skeleton.Text type="long" />
      <div className="u-marginTopXxxs">
        <Skeleton.Text type="short" />
      </div>
    </Block>
  </Card>
);

export default ListingSkeleton;
